import { AnyFieldMeta, useStore } from '@tanstack/react-form';
import { ZodError } from 'zod';
import { useFieldContext } from '.';

type FieldErrorsProps = {
  meta: AnyFieldMeta;
};

export const FieldErrors = ({ meta }: FieldErrorsProps) => {
  const field = useFieldContext<string>();
  const hasTriedToSubmit = useStore(
    field.form.store,
    (state) => state.submissionAttempts > 0
  );
  if (!meta.isTouched && !hasTriedToSubmit) return null;

  return meta.errors.map(({ message }: ZodError) => message).join(', ');
};
